<img src="/assets/images/planvue.png" class="logo" alt="Planvue Logo">
<p>Welcome to Plan VUE, the web based tool that combines event planning,
  branding and floorplans all into a Visual Understanding Environment (VUE)
  to assist you in bringing your event to life...</p>

<app-auth-button></app-auth-button>